
import { date as dateQuasar } from 'quasar'
import { MONTHS, OFFSET_MSK_MS } from './CalendarUtils.js'

export const calendarSearchParams = {
  methods: {
    getURLSearchParams: function (interval = null, statMonth = true) {
      const params = new URLSearchParams()

      if (statMonth) {
        const date = new Date()
        date.setDate(1)
        date.setMonth(MONTHS.indexOf(this.selectMonth))
        date.setYear(this.selectYear)

        const dateStr = dateQuasar.formatDate(date, 'YYYY-MM-DD')

        params.set('statMonth', dateStr)
      }

      if (!interval) {
        interval = {}
        if (this.neighboringMonths) {
          interval.start = Date.UTC(this.selectYear, MONTHS.indexOf(this.selectMonth), -1) - OFFSET_MSK_MS
          interval.end = Date.UTC(this.selectYear, MONTHS.indexOf(this.selectMonth) + 1, 2) - OFFSET_MSK_MS
        } else {
          interval.start = Date.UTC(this.selectYear, MONTHS.indexOf(this.selectMonth), 1) - OFFSET_MSK_MS
          interval.end = Date.UTC(this.selectYear, MONTHS.indexOf(this.selectMonth) + 1, 0) - OFFSET_MSK_MS
        }
      }

      params.set('start', interval.start)
      params.set('end', interval.end)

      if (this.isMobile === false) {
        const selectedRoles = localStorage.getItem('calendarSelectedRoles')
        if (selectedRoles) {
          params.set('role', selectedRoles.toString())
        }
      } else {
        params.set('role', 'brigadeemployee,office')
      }

      if (this.tab == 'drivers') {
        params.set('driverOnly', true)
      } else if (this.tab == 'contractor') {
        params.set('contractorOnly', true)
      }

      return params
    }
  }
}
